var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchClearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "#014780"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2845 9.4737L14.176 5.58218C14.2635 5.48006 14.3092 5.3487 14.304 5.21435C14.2988 5.08 14.2431 4.95256 14.148 4.85749C14.053 4.76242 13.9255 4.70673 13.7912 4.70154C13.6568 4.69635 13.5255 4.74205 13.4233 4.8295L9.53181 8.72102L5.64029 4.82416C5.53817 4.73671 5.40681 4.69101 5.27246 4.6962C5.13811 4.70139 5.01067 4.75708 4.9156 4.85215C4.82053 4.94722 4.76484 5.07466 4.75965 5.20901C4.75446 5.34336 4.80016 5.47472 4.88761 5.57684L8.77913 9.4737L4.88227 13.3652C4.82639 13.4131 4.781 13.472 4.74896 13.5382C4.71692 13.6044 4.69892 13.6766 4.69608 13.7501C4.69324 13.8236 4.70562 13.8969 4.73246 13.9654C4.7593 14.0339 4.80001 14.0961 4.85203 14.1481C4.90405 14.2002 4.96627 14.2409 5.03477 14.2677C5.10327 14.2945 5.17658 14.3069 5.2501 14.3041C5.32362 14.3013 5.39575 14.2833 5.46198 14.2512C5.52821 14.2192 5.5871 14.1738 5.63495 14.1179L9.53181 10.2264L13.4233 14.1179C13.5255 14.2054 13.6568 14.2511 13.7912 14.2459C13.9255 14.2407 14.053 14.185 14.148 14.0899C14.2431 13.9948 14.2988 13.8674 14.304 13.7331C14.3092 13.5987 14.2635 13.4673 14.176 13.3652L10.2845 9.4737Z",
    fill: "#014780"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClearIcon);
export default __webpack_public_path__ + "static/media/search_clear_icon.912eded2.svg";
export { ForwardRef as ReactComponent };